// stylelint-disable declaration-no-important

@each $value in $overflows {
  .overflow-#{$value} { overflow: $value !important; }
}
